/**
 * Return signupAction & signupUrl, to be added to advancedSettings
 */

export function buildSignupUrlAction(products: string[]) {
  return {
    advancedSettings: {
      additionalProvisioningData: {
        signupAction: products.map((product) => `created-${product}`).join('-'),
        signupUrl: window?.location?.href || ''
      }
    }
  };
}
